'use strict';

module.exports = function infinite(generate) {
  generate = generate || Math.random;
  return function (end, cb) {
    if (end) return cb && cb(end);
    return cb(null, generate());
  };
};